<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center text-center">
    <div class="col-12 col-xl-11">
      <h3>{{ 'You have successfully unsubscribed!'| translate }}</h3>
    </div>
  </div>
</div>
